import { Fragment } from 'react';

import { Dialog, Transition } from '@headlessui/react';
import { X } from 'lucide-react';

const SideDrawer = ({
    isOpen,
    onDismiss,
    onCloseButtonClick,
    afterEnter,
    afterLeave,
    title,
    subtitle,
    header,
    footer,
    children,
    widthClassName = 'max-w-[420px]',
    contentClassName = 'flex-1 overflow-y-auto p-[22px]'
}) => (
    <Transition.Root show={isOpen} as={Fragment} appear afterEnter={afterEnter} afterLeave={afterLeave}>
        <Dialog as="div" className="relative z-[100010]" onClose={() => onDismiss && onDismiss()}>

            <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-gray-900/50 transition-opacity" aria-hidden="true" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full sm:pl-10">

                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-300"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-300"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <Dialog.Panel className={`pointer-events-auto w-screen ${widthClassName}`}>
                                <div className="flex h-full flex-col bg-white shadow-xl">

                                    <div className="flex flex-none items-center justify-between border-b border-gray-200 px-[22px] py-[18px]">
                                        <div>
                                            <Dialog.Title className="text-[15px] font-semibold text-gray-900">
                                                {title}
                                            </Dialog.Title>
                                            {subtitle && (
                                                <p className="mt-0.5 text-sm text-gray-500">{subtitle}</p>
                                            )}
                                        </div>

                                        {onCloseButtonClick && (
                                            <button
                                                type="button"
                                                aria-label="Fechar painel"
                                                className="flex h-[30px] w-[30px] items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-primary"
                                                onClick={onCloseButtonClick}
                                            >
                                                <X className="h-[18px] w-[18px]" />
                                            </button>
                                        )}
                                    </div>

                                    {header && (
                                        <div className="flex-none border-b border-gray-200 px-[22px] py-3">
                                            {header}
                                        </div>
                                    )}

                                    <div className={contentClassName}>
                                        {children}
                                    </div>

                                    {footer && (
                                        <div className="flex-none border-t border-gray-200 px-[22px] py-4">
                                            {footer}
                                        </div>
                                    )}

                                </div>
                            </Dialog.Panel>
                        </Transition.Child>

                    </div>
                </div>
            </div>

        </Dialog>
    </Transition.Root>
);

export default SideDrawer;
